import React from 'react'
import moment from 'moment'
import { getLastEventLogName } from '../../helpers/lastEventLogHelper'
import './FirstReturnEventSummary.css'

type Props = {
  eventLog?: ILastEventLog | null
}

const FirstReturnEventSummary = ({ eventLog }: Props) => {
  if (eventLog === undefined) return null
  if (eventLog === null) return <span>返却記録なし</span>

  const detectedAt = eventLog.at ? moment.parseZone(eventLog.at, moment.ISO_8601, true) : null
  const validDate = detectedAt?.isValid() ?? false

  return (
    <div className="first-return-event-summary">
      <div>{getLastEventLogName(eventLog)}</div>
      {eventLog.source_name && <div>{eventLog.source_name}</div>}
      {validDate ? (
        <time dateTime={eventLog.at!}>
          {detectedAt!.utcOffset(9 * 60).format('YYYY/MM/DD HH:mm:ss')}
          （JST）
        </time>
      ) : <span>日時不明</span>}
    </div>
  )
}

export default FirstReturnEventSummary
